import request from '../../axios';
import {ICreateStoreOrderCardToCardTransactionPayload} from './types';

const postPaymentStoreOrderCardToCardTransaction = async (
  payload: ICreateStoreOrderCardToCardTransactionPayload,
) => {
  const formData = new FormData();
  formData.append('store_order', payload?.store_order);
  formData.append('image', payload?.image);
  formData.append('payment_type', payload?.payment_type.toString());

  const {data} = await request.post(
    `/api/v2/payment/payment-store-order-transaction-card-to-card`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );
  return data;
};

export default postPaymentStoreOrderCardToCardTransaction;
